module.exports = __webpack_public_path__ + "img/celtic1.78741034.jpg";